import MetaTagsComponent from 'Components/MetaTagsComponent'
import './styles.scss'
import React from 'react'
import { TRADE_BOX } from 'Utils/Constants'
import { t } from 'i18next'

function CoffeeTradeBox() {
  return (
    <>
      <MetaTagsComponent title={t('TRADE_BOX_TITLES')} description={t('TRADE_BOX_DESCRIPTION')} keywords={t('TRADE_BOX_KEYWORDS')} url="https://coffeeweb.com/traderequest" h1Content={t('TRADE_BOX_H1_CONTENT')} />
      <div className="trade-box-container">
        <video controls className="trade-box-image" autoPlay loop playsInline>
          <source src={TRADE_BOX.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  )
}

export default CoffeeTradeBox
